import type { ProgressSpinnerDesignTokens } from '@primeuix/themes/types/progressspinner';

 export default {
    colorScheme: {
        light: {
            root: {
                colorOne: "{primary.color}",
                colorTwo: "{primary.color}",
                colorThree: "{primary.color}",
                colorFour: "{primary.color}"
            }
        },
        dark: {
            root: {
                colorOne: "{primary.color}",
                colorTwo: "{primary.color}",
                colorThree: "{primary.color}",
                colorFour: "{primary.color}"
            }
        }
    }
} satisfies ProgressSpinnerDesignTokens;